import { render, staticRenderFns } from "./LabelForCefrSegmentContentDataInput.vue?vue&type=template&id=3a9e42a4&"
import script from "./LabelForCefrSegmentContentDataInput.vue?vue&type=script&lang=js&"
export * from "./LabelForCefrSegmentContentDataInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports